import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useShallow } from 'zustand/react/shallow';

import useSearchStore from '@/apps/mwd-v2/state/selectors/useSearchStore';
import useSearchApi from '@/components/search/hooks/useSearchApi';
import { SearchParams, SearchRequests } from '@/components/search/types';
import useClientState from '@/state/useClientState';
import { WerklijnenInline } from '@/types/werklijnenInline';
import { toastSuccessOptions } from '@/utils/toastOptions';

/**
 * This hook has been created to re-use logic in the refactor without chaning its nature. Its prefrerred to refactor this to use state and utils.
 */
const useSearchAndSidebarWerklijnen = () => {
  const {
    searchParams,
    showAdvancedSearchDialog,
    setShowAdvancedSearchDialog,
    clearSearchField,
    setClearSearchField,
    advancedSearchParams,
    setAdvancedSearchParams,
  } = useSearchStore();

  const { searchInputParams, isFetching: isSearching, searchAdvanced, handleSearchStatus } = useSearchApi();

  const [clearAdvancedSearchData, setClearAdvancedSearchData] = useState(false);
  const nieuweWerklijnIds = useClientState(useShallow((state) => state.nieuweWerklijnIds));
  const resetNieuweWerklijnIds = useClientState(useShallow((state) => state.resetNieuweWerklijnIds));

  /** Called onUserSearchIntent */
  const performSearchRequest = (p: SearchParams, add = false) => {
    setClearAdvancedSearchData(true);
    searchInputParams(p, { add });
    window.scrollTo(window.scrollX, 0);
  };

  /**
   * This is the handle to set the search result from AdvancedSearch.
   * @param data
   * @param voegWerklijnenToe
   * @returns
   */
  const handleAdvancedSearchData = (data: WerklijnenInline | undefined | null, voegWerklijnenToe: boolean) => {
    if (!data?.werklijnen) return;
    const { werklijnen } = data;
    handleSearchStatus(werklijnen, { add: voegWerklijnenToe, redirectNoSearchResult: true, showErrorToast: true });
    window.scrollTo(window.scrollX, 0);
  };

  // Toon werklijnen vanuit sidebar informatie
  const handleSelectieUitPanel = (advancedSearchData: SearchRequests, { suppressToast = false } = {}) => {
    setClearSearchField(true);
    searchAdvanced(advancedSearchData, {
      add: true,
      suppressToast,
      showErrorToast: !suppressToast,
    });
    window.scrollTo(window.scrollX, 0);
  };

  useEffect(() => {
    localStorage.removeItem('selectedWleId');
    sessionStorage.removeItem('advancedSearchValues');
  }, []);

  useEffect(() => {
    // Clear zoekbalk met nieuwe zoek queries/toevoegen van werklijnen
    setClearSearchField(Boolean(searchParams === null));
  }, [searchParams]);

  // Provide feedback for newly added werklijnen.
  useEffect(() => {
    if (nieuweWerklijnIds.length > 0) {
      const timer = setTimeout(() => {
        resetNieuweWerklijnIds();
      }, 5000);

      toast.success(
        nieuweWerklijnIds.length > 1
          ? `Er zijn ${nieuweWerklijnIds.length} nieuwe werklijnen toegevoegd`
          : `Er is 1 nieuwe werklijn toegevoegd`,
        {
          ...toastSuccessOptions,
          toastId: 'successfullyAddedWerklijnen',
        },
      );

      return () => {
        clearTimeout(timer);
      };
    }
  }, [nieuweWerklijnIds]);

  return {
    advancedSearchParams,
    clearAdvancedSearchData,
    clearSearchField,
    handleAdvancedSearchData,
    handleSelectieUitPanel,
    isFetching: isSearching,
    performSearchRequest,
    searchParams,
    setAdvancedSearchParams,
    setShowAdvancedSearchDialog,
    showAdvancedSearchDialog,
  };
};
export default useSearchAndSidebarWerklijnen;
